module.exports = __webpack_public_path__ + "img/htp-slide-one.41d48406.png";